export function generateStudentLoginId(
  existingLoginIds: string[],
  material: { schoolId: string; studentId: string }
) {
  const baseId = `${material.schoolId}-${material.studentId}`;
  const idSet = new Set(existingLoginIds);

  let loginId = baseId;
  let i = 1;

  while (idSet.has(loginId)) {
    loginId = `${baseId}-${i}`;
    i++;
  }

  return loginId;
}

export function generateNewStudentId(existingIds: string[], order = 1): string {
  const idSet = new Set(existingIds);
  let newId = order.toString().padStart(3, "0");

  while (idSet.has(newId)) {
    order++;
    newId = order.toString().padStart(3, "0");
  }

  return newId;
}

export function breakDownReferencePath(studentRefPath: string) {
  if (!studentRefPath) {
    return {
      schoolId: "",
      classroomId: "",
      studentId: ""
    };
  }
  const splitted = studentRefPath.split("/");
  return {
    schoolId: splitted[1],
    classroomId: splitted[3],
    studentId: splitted[5]
  };
}
